import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Gallery from "../components/Gallery";
import Contact from "../components/Contact";
import WhatsAppButton from "../components/WhatsAppButton";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Gallery />
      <Contact />

      <WhatsAppButton/>
    </>
  );
}
